export enum EGroupBookingEventName {
  GROUP_BOOKING_REQUEST_SUBMITTED = 'Group Booking Request Submitted',
}

export interface IGroupBookingRequestSubmittedEvent {
  page: string;
  eventType: string;
  location: string;
  numberOfRvs: number;
  groupSize: string;
}
